import React from 'react';
import { formService } from '../../../form-service';
import { TextInputExtended } from './core/text-input-extended';

interface Props {
	name: string;
	label?: string;
	value?: string;
	required?: boolean;
	infoMessage?: string;
}

const regExp = /^ *[a-zA-ZÀ-ÿ\u00f1\u00d1]+(?:(?: +|-)[a-zA-ZÀ-ÿ\u00f1\u00d1]+)* *$/;

export function LettersInput(props: Props) {
	return (
		<TextInputExtended
			{...props}
			label={props.label || 'Nombre'}
			validate={(value) => regExp.test(value)}
			onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
				event.target.value = event.target.value.replace(/ +/g, ' ');
			}}
			onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
				const value = event.target.value.trim();
				event.target.value = value;
				formService.setFieldValue(props.name, value);
			}}
			errorMessage="Solo se aceptan letras"
		/>
	);
}
